import React from 'react';
import memoize from 'memoize-one';
import { ApprovementStatus, ApproveRejectActions, ButtonTooltip, Icon } from '../../../components';

const columns = memoize(clickHandler => [
  {
    name: 'FECHA DE SOLICITUD',
    selector: 'created_at',
    sortable: true,
    grow: 2,
    center: true
  },
  {
    name: 'MONTO',
    selector: 'parsed_amount',
    cell: item => item.parsed_amount,
    sortable: true,
    grow: 1,
    center: true
  },
  {
    name: 'FECHA DE OTORGAMIENTO',
    selector: 'grant_date',
    sortable: true,
    grow: 2,
    center: true
  },
  {
    name: 'PRIMER DESCUENTO',
    selector: 'start_date',
    sortable: true,
    grow: 2,
    center: true
  },
  {
    name: 'ESTADO',
    selector: 'status',
    cell: item => <ApprovementStatus status={item.status} onClick={() => clickHandler(item, 'show')} />,
    sortable: true,
    grow: 1,
    center: true
  },
  {
    name: 'APROBAR',
    cell: item => (
      <ApproveRejectActions
        resource="Loan"
        item={item}
        clickHandler={clickHandler}
        approveText={item.request_reviewer_signature ? 'Firmar' : 'Aprobar'}
      />
    ),
    ignoreRowClick: true,
    allowOverflow: false,
    minWidth: '110px',
    grow: '0.5'
  },
  {
    name: 'ACCIONES',
    cell: item => (
      <ButtonTooltip
        variant="circle-danger"
        className="btn-circle"
        onClick={() => clickHandler(item, 'destroy')}
        text="Eliminar"
      >
        <Icon icon="trash" />
      </ButtonTooltip>
    ),
    ignoreRowClick: true,
    allowOverflow: false,
    button: true,
    grow: 1,
    center: true
  }
]);

export default columns;
